import { TaskTypeBadgeEnum } from "./TaskBadge/types";

type ColorPropsTaskType = {
  background: string;
  color: string;
};

const getColorsObject = (background: string, color: string): ColorPropsTaskType => ({
  background,
  color,
});

const getColorByTask = (taskType?: string) => {
  if (!taskType) return getColorsObject("#EAECF5", "#308CDB");

  switch (taskType?.toUpperCase()) {
    case TaskTypeBadgeEnum.GENERAL:
      return getColorsObject("#FEE4E2", "#D92D20");
    case TaskTypeBadgeEnum.UPLIFT:
      return getColorsObject("#FEF0C7", "#DC6803");
    case TaskTypeBadgeEnum.DELIVERY:
      return getColorsObject("#D1E9FF", "#1570EF");
    case TaskTypeBadgeEnum.LOCAL:
      return getColorsObject("#C7D7FE", "#444CE7");
    case TaskTypeBadgeEnum.DROP_OFF:
      return getColorsObject("#F4EBFF", "#42307D");
    case TaskTypeBadgeEnum.PRE_PACK:
    case TaskTypeBadgeEnum.PRE_PACK2:
    case TaskTypeBadgeEnum.PACK:
      return getColorsObject("#FCCEEE", "#DD2590");
    case TaskTypeBadgeEnum.PICKUP:
      return getColorsObject("#E0F2FE", "#0B4A6F");
    case TaskTypeBadgeEnum.IMPORT:
      return getColorsObject("#F2F4F7", "#475467");
    case TaskTypeBadgeEnum.HOME_SURVEY:
    case TaskTypeBadgeEnum.VIDEO_SURVEY:
      return getColorsObject("#FCE7F6", "#851651");
    case TaskTypeBadgeEnum.PREFERRED_UPLIFT:
      return getColorsObject("#D1FADF", "#039855");
    default:
      return getColorsObject("#EAECF5", "#308CDB");
  }
};

export default getColorByTask;
